<ul class="mt-1 mb-1">
    @for (submenu of treeDataSubmenus; track submenu) {
        <li class="bullet-list">
            <table>
                @if (checkMenuCondition(submenu) | async) {
                    <tr>
                        <td class="w-15px">
                            @if (submenu.submenus.length && (checkSubMenusConditions(submenu) | async)) {
                                <li
                                    [id]="submenu.id"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseExample"
                                    [attr.aria-expanded]="getToggleState(submenu.id)"
                                    aria-controls="collapseExample"
                                    value="false"
                                    (click)="toggle(submenu.id)"
                                    [class.fa-angle-down]="getToggleState(submenu.id)"
                                    [class.fa-angle-right]="!getToggleState(submenu.id)"
                                    class="fas"
                                ></li>
                            }
                        </td>
                        <td class="properties-tree-item">
                            <a [id]="submenu.id + '_node'" [attr.hierarchyPath]="hierarchyPath + submenu.id + '/'" class="tree-node" (click)="onMenuClick(submenu.id)"> {{ submenu.displayName.en }}</a>
                        </td>
                    </tr>
                }
            </table>

            <div class="collapse" id="collapseExample" [ngClass]="{ show: getToggleState(submenu.id) }">
                <div class="ps-3">
                    @if (submenu.submenus.length > 0) {
                        <app-properties-tree-view
                            [treeDataSubmenus]="submenu.submenus"
                            [treeDataContent]="submenu.contents"
                            [hierarchyPath]="hierarchyPath + submenu.id + '/'"
                            (menuItemClicked)="onMenuClick($event)"
                        ></app-properties-tree-view>
                    }
                </div>
            </div>
        </li>
    }
</ul>
